module.exports = __webpack_public_path__ + "assets/img/favicon/android-icon-144x144.fdd92b43becfe8b618beff99fcbbfa4e.png";